import { useState, useEffect } from 'react';
import { Flex, Image } from '../../../2022-component-library';
import { useReceiveMessage } from '../../../context/messageContext';
import { PatientFacialDetection } from '../../../components';

const ResponsiveKaysOptotypesTestPatient = () => {
  const [currentOptotypeIndex, setCurrentOptotypeIndex] = useState(0);
  const messageFromOptician = useReceiveMessage();
  const [testMode, setTestMode] = useState('');
  const [logmarData, setLogmarData] = useState({});
  const [optotypes, setOptotypes] = useState([]);
  const [imageIsCrowded, setImageIsCrowded] = useState(false);

  useEffect(() => {
    const importOptotypes = (src) => src.keys().map(src);
    const optotypes = importOptotypes(require.context('../../../assets/kays-optotypes', false, /\.svg$/));
    setOptotypes(optotypes);
  }, []);

  useEffect(() => {
    setCurrentOptotypeIndex(logmarData.currentOptotypeIndex);
  }, [logmarData.currentOptotypeIndex]);

  useEffect(() => {
    switch (messageFromOptician.type) {
      case 'kaysOptotypes':
        setImageIsCrowded(messageFromOptician.content.crowding === 'crowded');
        if (messageFromOptician.content.methodSelected !== 'manual') {
          setTestMode('auto');
        } else {
          setTestMode(messageFromOptician.content.testMode);
        }
        setLogmarData({
          size: messageFromOptician.content.contentSize,
          distance: messageFromOptician.content.distanceFromScreen,
          currentOptotypeIndex: messageFromOptician.content.currentOptotypeIndex,
          methodSelected: messageFromOptician.content.methodSelected,
        });
        break;
      case 'resizeOptotype':
        setLogmarData({
          size: messageFromOptician.content.contentSize,
          distance: messageFromOptician.content.distanceReferenceInMM,
          currentOptotypeIndex: messageFromOptician.content.currentOptotypeIndex,
        });
        break;
      default:
        break;
    }
  }, [messageFromOptician]);

  return (
    <Flex>
      <PatientFacialDetection testMode={testMode} />
      <Flex width='100vw' centered height='100vh' style={{ zIndex: '9' }}>
        <Flex style={{ ...(imageIsCrowded && { borderStyle: 'solid', borderWidth: logmarData.size / 8, padding: logmarData.size / 3 }) }}>
          <Image src={optotypes[currentOptotypeIndex]?.default} alt='kays-optotype' width={logmarData.size} height={logmarData.size} />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ResponsiveKaysOptotypesTestPatient;
